// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__DIzHn","amount":"Chart_amount__Im305"};